import { render, staticRenderFns } from "./RedPoint.vue?vue&type=template&id=fc8fb1e0&scoped=true&"
import script from "./RedPoint.vue?vue&type=script&lang=js&"
export * from "./RedPoint.vue?vue&type=script&lang=js&"
import style0 from "./RedPoint.vue?vue&type=style&index=0&id=fc8fb1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8fb1e0",
  null
  
)

export default component.exports